/** Theme-aware surface helpers for Aria Handsoff inbox UI chrome. */

export const ariaPanelBorderSx = {
  borderColor: 'divider',
};

export const ariaShellSx = {
  border: '1px solid',
  borderColor: 'divider',
  bgcolor: 'background.paper',
};

export const ariaMutedPanelSx = {
  bgcolor: 'background.default',
  borderColor: 'divider',
};

/** Put the color in the shorthand so md breakpoints do not reset to black `currentColor`. */
export const ariaColumnDividerSx = {
  borderRight: (theme) => ({
    xs: 'none',
    md: `1px solid ${theme.palette.divider}`,
  }),
};

export const ariaCardSurfaceSx = {
  bgcolor: 'background.paper',
  border: '1px solid',
  borderColor: 'divider',
};

export const ariaSelectedListItemSx = (theme) => ({
  bgcolor: theme.portal?.accentSoft ?? theme.palette.action.selected,
  '&:hover': {
    bgcolor: theme.portal?.accentSoft ?? theme.palette.action.selected,
  },
});

export const ariaListItemHoverSx = {
  '&:hover': { bgcolor: 'action.hover' },
};

export const ariaSegmentTrackSx = {
  display: 'flex',
  alignItems: 'stretch',
  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
};

export const ariaSegmentTabSx = (selected, theme) => ({
  appearance: 'none',
  color: selected ? 'primary.main' : 'text.secondary',
  bgcolor: 'transparent',
  boxShadow: 'none',
  borderRadius: 0,
  border: 'none',
  borderBottom: selected ? `2px solid ${theme.palette.primary.main}` : '2px solid transparent',
  mb: '-1px',
  outline: 'none',
  '&:hover': {
    color: selected ? 'primary.main' : 'text.primary',
    bgcolor: 'action.hover',
  },
});

export const ariaQueueCountChipSx = (selected, theme) => ({
  color: selected ? 'common.white' : 'text.secondary',
  bgcolor: selected ? 'primary.main' : theme.palette.action.hover,
});

export const ariaQueueStripButtonSx = (selected, theme) => ({
  border: '1px solid',
  borderColor: selected ? 'primary.main' : 'divider',
  bgcolor: selected ? (theme.portal?.accentSoft ?? 'action.selected') : 'background.paper',
  color: selected ? 'primary.main' : 'text.primary',
  '&:hover': {
    bgcolor: selected ? (theme.portal?.accentSoft ?? 'action.selected') : 'action.hover',
  },
});

export const ariaQueueRailItemSx = (selected, theme) => ({
  borderLeft: selected ? '3px solid' : '3px solid transparent',
  borderLeftColor: selected ? 'primary.main' : 'transparent',
  '&.Mui-selected': ariaSelectedListItemSx(theme),
  ...ariaListItemHoverSx,
});

export const ariaAvatarFallbackSx = {
  bgcolor: 'action.hover',
  color: 'text.secondary',
};
